import clsx from "clsx";

const Dropdown = ({ onSelect, suggestions, className }) => {
  if (!suggestions || !suggestions.length) {
    return null;
  }

  const handleSelect = company => () => {
    if (onSelect) {
      onSelect(company);
    }
  };

  return (
    <ul
      id="dropdown"
      className={clsx("autosuggest-widget-dropdown active", {
        [className]: className
      })}
    >
      {suggestions.map(company => (
        <li
          key={company.duedilId}
          onClick={handleSelect(company)}
          role="tab"
          tabIndex={-1}
        >
          <span className="autosuggest-widget-item-name">{company.name}</span>
          <span className="autosuggest-widget-item-address">
            {company.address}
          </span>
        </li>
      ))}
    </ul>
  );
};

Dropdown.defaultProps = {
  suggestions: []
};

export default Dropdown;



// WEBPACK FOOTER //
// ./AutoComplete/components/Dropdown.js